import React from "react";
import AboutSection from "../components/AboutSection";
import ContactSection from "../components/ContactSection";
import LandingHome from "../components/LandingHome";

const LandingPage = () => {
  return (
    <>
      <LandingHome />
      <AboutSection />
      <ContactSection />
    </>
  );
};

export default LandingPage;
